import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Returns() {
  return (
    <div className="terms">
      <Header />
      <main className="content">
        <div className="ct__richtext">
          <p>
            <br />
          </p>
          <h3>Rivergrove Return Policy</h3>
          <p>
            Learn about Rivergrove's return policy for the United States and
            internationally.
          </p>
          <h3>Shipping and Returns – United States</h3>
          <p>
            <b>Free expedited shipping and free returns.</b>
          </p>
          <p>
            Rivergrove offers free standard shipping for orders below €48.99,{" "}
            <Link onClick={toTop} to="/">
              {" "}
              free expedited shipping{" "}
            </Link>{" "}
            for orders over €49, and free returns for all orders purchased on{" "}
            <Link onClick={toTop} to="/">
              www.rivergrove.blog
            </Link>
            . Visit{" "}
            <Link onClick={toTop} to="/terms">
              Rivergrove's Terms and Conditions
            </Link>{" "}
            for more details.
          </p>
          <p>
            <b>
              What are my shipping options? Do you offer overnight or expedited
              shipping?
            </b>
            <br />
          </p>
          <ul>
            <li>
              <b style={{ fontSize: "1em" }}>For orders under €48.99:</b>{" "}
              Standard shipping is free and expedited shipping costs €12.00.
            </li>
            <li>
              <b style={{ fontSize: "1em" }}>
                Orders €49.00 and above qualify for free expedited shipping.
              </b>{" "}
              The order subtotal must be a minimum of €49.99 to qualify.
            </li>
            <li>
              <b style={{ fontSize: "1em" }}>
                All Canadian orders are shipped at no cost
              </b>{" "}
              via International Economy, which generally takes five to seven
              days.
            </li>
            <li>
              <b style={{ fontSize: "1em" }}>Replacements</b> may require an
              extra 24-48 hours processing time.
            </li>
          </ul>
          <p>
            <b>When will my order ship?</b>
            <br />
            <br />
            Most orders ship within 24-48 hours, and you'll receive{" "}
            <Link onClick={toTop} to="/returns">
              shipment tracking information
            </Link>
            .
          </p>
          <p>
            <b>When will I receive my order?</b>
            <br />
            <br />
            After your order ships:
            <br />
          </p>
          <ul>
            <li>Standard shipping usually arrives in 3-5 business days.</li>
            <li>Expedited shipping usually arrives in 1-3 days.</li>
            <li>
              Holiday orders may take longer due to shipping delays with the
              USPS and other carriers.
            </li>
          </ul>
          <p>
            <b>
              Can I cancel my{" "}
              <Link onClick={toTop} to="/">
                www.rivergrove.blog
              </Link>{" "}
              order?
            </b>
            <br />
          </p>
          <p>
            Most{" "}
            <Link onClick={toTop} to="/">
              www.rivergrove.blog
            </Link>{" "}
            orders can be canceled on your own within 45-minutes of placing it
            using the steps below. After 45-minutes, cancellations are no longer
            possible because your order will have been sent to our fulfillment
            center. Once the order is delivered you can return it within 45 days
            for a full refund. For more information, visit our{" "}
            <Link onClick={toTop} to="/contact">
              help article
            </Link>
            .
          </p>
          <p>
            <b>How do I return a Rivergrove product?</b>
            <br />
            <br />
            Rivergrove offers a 45-day refund policy from the date you receive
            your order to request a full refund.
            <br />
            <br />
            For order numbers starting with <strong>001</strong> (example:
            001-1234567), you can begin the return process by visiting{" "}
            <Link onClick={toTop} to="/returns">
              Returns
            </Link>
            .
            <br />
            <br />
            Tip: You can find your order number in the body and the subject of
            your Rivergrove order confirmation email. Search the email subject
            “Confirming Your Rivergrove Order” in your inbox.
            <br />
            <br />
            For order numbers starting with <strong>004</strong> (example:
            004-1234567), please contact our Customer Support Team at{" "}
            <strong>1-800-656-1918</strong>.
            <br />
            <br />
            Once completed, you will be able to print a ground shipping return
            label along with instructions on how to pack up and return your
            Rivergrove products.
            <br />
            <br />
            <strong>
              How do I return multiple Rivergrove products or Rivergrove
              bundles?
            </strong>
            <br />
          </p>
          <p>
            If you want to return a bundle, like Rivergrove Alarm 14-Piece Kit
            plus Echo Dot or a Rivergrove Doorbell with Chime Pro, we recommend
            calling our Customer Support Team at <strong>1-800-656-1918</strong>{" "}
            so they can help you with your return.
            <br />
            <br />
            <strong>
              Does it cost anything to return my Rivergrove product?
            </strong>
            <br />
          </p>
          <p>
            No, there is no charge for returns that are within the 45-day refund
            time period.
            <br />
            <br />
            <strong>Can I track my return?</strong>
            <br />
          </p>
          <p>
            Yes. After completing the return process, you will receive a
            confirmation email. There is a tracking link in the email you can
            use to track your package.
          </p>
          <p>
            <Link onClick={toTop} to="/">
              Learn more about checking your order status.
            </Link>
            <br />
            <br />
            <strong>
              Can I return a Rivergrove product that I purchased on Amazon or at
              retail?
            </strong>
            <br />
          </p>
          <p>
            No. This return process can only be used for products purchased
            through www.rivergrove.blog. Products purchased through other
            outlets must be returned using those outlets' return procedures.
            <br />
            <br />
            <strong>How will I get my refund?</strong>
            <br />
          </p>
          <p>
            Once we receive your product(s), the full amount of the returned
            devices will be refunded to the original payment source used within
            7 to 10 business days.
            <br />
            <br />
            <strong>Where do these return policies apply?</strong>
            <br />
          </p>
          <p>
            These policies only apply within the United States.
            <br />
            <br />
          </p>
          <h3>Shipping and Returns – International</h3>
          <p>
            <br />
          </p>
          <p>
            <strong>UK</strong>
          </p>
          <ul>
            <li>
              <Link onClick={toTop} to="/returns">
                Delivery and Returns Policy
              </Link>
            </li>
          </ul>
          <p>
            <strong>Nordics (Sweden, Denmark, Finland)</strong>
          </p>
          <ul>
            <li>
              <Link onClick={toTop} to="/returns">
                Delivery and Returns Policy
              </Link>
            </li>
          </ul>
          <p>
            <strong>Australia</strong>
          </p>
          <ul>
            <li>
              <Link onClick={toTop} to="/returns">
                Delivery and Returns Policy
              </Link>
            </li>
          </ul>
          <p>
            <strong>New Zealand</strong>
          </p>
          <ul>
            <li>
              <Link onClick={toTop} to="/returns">
                Delivery and Returns Policy
              </Link>
            </li>
          </ul>
          <p>
            <strong>Rest of Europe</strong>
          </p>

          <p>
            <br />
            <strong>Which countries does Rivergrove ship to?</strong>
            <br />
          </p>
          <p>
            We ship to the following countries:
            <br />
          </p>
          <p>
            United States
            <br />
            Canada
            <br />
            Austria
            <br />
            Belgium
            <br />
            Bulgaria
            <br />
            Croatia
            <br />
            Cyprus
            <br />
            Czech Republic
            <br />
            Denmark
            <br />
            Estonia
            <br />
            Finland
            <br />
            France
            <br />
            Germany
            <br />
            Greece
            <br />
            Hungary
            <br />
            Iceland
            <br />
            Ireland
            <br />
            Italy
            <br />
            Latvia
            <br />
            Lithuania
            <br />
            Luxembourg
            <br />
            Malta
            <br />
            Netherlands
            <br />
            Norway
            <br />
            Poland
            <br />
            Portugal
            <br />
            Romania
            <br />
            Saudi Arabia
            <br />
            Slovakia
            <br />
            Slovenia
            <br />
            South Africa
            <br />
            Spain
            <br />
            Sweden
            <br />
            United Arab Emirates
            <br />
            United Kingdom
            <br />
            Australia
            <br />
            New Zealand
            <br />
            <br />
            <br />
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Returns;
